import { render, staticRenderFns } from "./HotelOrderStatusTag.vue?vue&type=template&id=6e81c4ab&"
import script from "./HotelOrderStatusTag.vue?vue&type=script&lang=js&"
export * from "./HotelOrderStatusTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports